import Link from "../menu/link";
import Card from "../layout/card";
import H4 from "../font/H4";
import ReactMarkdown from "react-markdown";
import { useState, useEffect } from 'react';

function previewSentence(sentence) {
    if (sentence.length <= 200) {
      return sentence;
    } else {
      return sentence.slice(0, 200) + '...';
    }
  }

function BlogPreview(props) {
  const { post } = props;
  const postPreview = previewSentence(post.content);
  
  // Use a default property landscape image if one is not provided in local data
  const imageUrl = post.image || 'https://images.unsplash.com/photo-1556910103-1c02745a872f?auto=format&fit=crop&q=80&w=2070';

  return (
    <div className="drop-shadow-xl bg-lightblue flex flex-col items-center justify-top gap-4 w-80 rounded-lg">
            {imageUrl && (
        <div className="w-full h-48 rounded-t-lg overflow-hidden">
          <img
            src={imageUrl}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>
      )}
            <div className="flex flex-col px-8 pb-8 gap-4">
                <H4> {post.title} </H4>
                <ReactMarkdown>{postPreview}</ReactMarkdown>
            </div>
    </div>
  );
}

export default BlogPreview;